import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles({
  list: {
    width: 400,
  },
  fullList: {
    width: 'auto',
  },
  cardStyle: {
    background: '#F5F5F5',
    boxShadow: 'none',
  },
})

export default useStyles
